import script from "./EditFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditFormPage.vue?vue&type=script&setup=true&lang=js"

import "./EditFormPage.vue?vue&type=style&index=0&id=5e4459a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4459a4"]])

export default __exports__